export default __webpack_public_path__ + "static/media/funplex.c7565188.webp";